import { gql } from '@apollo/client';
export const PortLegs = gql `
  query portLegs($journeyType: JourneyType) {
    portLegs(journeyType: $journeyType) {
      originPort {
        portName
        portCode
      }
      allowedDestinations {
        portName
        portCode
      }
    }
  }
`;
export const DepartureCalender = gql `
  query DepartureCalender($originPort: String!, $destinationPort: String!) {
    departures(originPort: $originPort, destinationPort: $destinationPort) {
      departureDate
    }
  }
`;
// PortLegsByProductCode
export const GetProductCodeData = gql `
  query GetPortLegsByProductCode($code: String!, $lang: String) {
    journeyTypes(productCode: $code)
    promotionRules(promotionCode: $code) {
      promotionCode
      promotionStartDate
      promotionEndDate
      travelStartDate
      travelEndDate
      bannerText {
        nb
        en
        da
        nl
      }
      bannerBgColor
      bannerImageUrl
    }
    productRules(productCode: $code, language: $lang) {
      productName
      minNumPassengers
      maxNumPassengers
      allowedJourneys {
        originPort
        destinationPort
        requireReturnOnSameDay
      }
      vehiclesRequired
      vehiclesAllowed
    }
    portLegs(productCode: $code) {
      originPort {
        portCode
        portName
      }
      allowedDestinations {
        portCode
        portName
      }
    }
  }
`;
export const GetProductRulesData = gql `
  query GetProductRulesData($code: String!, $lang: String) {
    journeyTypes(productCode: $code)
    productRules(productCode: $code, language: $lang) {
      productName
      minNumPassengers
      maxNumPassengers
      allowedJourneys {
        originPort
        destinationPort
        requireReturnOnSameDay
      }
      vehiclesRequired
      vehiclesAllowed
    }
    portLegs(productCode: $code) {
      originPort {
        portCode
        portName
      }
      allowedDestinations {
        portCode
        portName
      }
    }
  }
`;
export const GetPromotionRulesData = gql `
  query GetPromotionRulesData($code: String!) {
    journeyTypes(productCode: $code)
    promotionRules(promotionCode: $code) {
      promotionCode
      promotionStartDate
      promotionEndDate
      travelStartDate
      travelEndDate
      bannerText {
        nb
        en
        da
        nl
      }
      bannerBgColor
      bannerImageUrl
    }

    portLegs(productCode: $code) {
      originPort {
        portCode
        portName
      }
      allowedDestinations {
        portCode
        portName
      }
    }
  }
`;
export const CheckIfValidFlCode = gql `
  query CheckIfValidFlCode($code: String!) {
    flCode(code: $code) {
      codeValue
      codeType
      isValidCode
      __typename
    }
  }
`;
export const AvailabilityRequest = gql `
  query CheckAvailability($requestParams: AvailabilityRequestInput!) {
    availability(requestParams: $requestParams) {
      isJourneyAvailable
    }
  }
`;
export const DepartureDateCalendarByProductcode = gql `
  query GetDepartureCalendarByProductcode($originPort: String!, $destinationPort: String!, $productCode: String) {
    departures(originPort: $originPort, destinationPort: $destinationPort, productCode: $productCode) {
      departureDate
      __typename
    }
  }
`;
//# sourceMappingURL=queries.js.map